export const CHECKBOX = 'checkbox';

export const FULL_NAME = 'fullName';

export const ORGANIZATION_ROLE = 'organizationRole';

export const PROJECT_MEMBERSHIPS = 'projectMemberships';

export const TFA = 'tfa';

export const LAST_LOGIN_AT = 'lastLoginAt';

export const CREATED_AT = 'createdAt';

export const ACTIONS = 'actions';

export const TABLE_GRID_8_COLUMNS = `
    40px
    minmax(260px,1fr) 
    minmax(140px,1fr)
    minmax(160px,1fr)
    minmax(60px,1fr)
    minmax(140px,1fr)
    minmax(140px,1fr)
    40px
`;

export const TABLE_GRID_7_COLUMNS = `
    40px
    minmax(260px,1fr)
    minmax(140px,1fr)
    minmax(160px,1fr)
    minmax(140px,1fr)
    minmax(140px,1fr)
    40px
`;
